import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberSuffix'
})
export class NumberSuffixPipe implements PipeTransform {

  transform(value: number): string {
    if (value >= 1000) {
      return (value / 1000).toFixed(2) + 'k';
    }
    return value.toString();
  }

}
